import { StatoEntita } from '../tipologiche/stato-entita';

export class DatiDenuncia {
    id: String;
    tipoDenuncia: StatoEntita;
    numero: number;
    anno: number;
    dataDenuncia: number;
}
